export const SHOW_SNACKBAR = 'src/containers/SHOW_SNACKBAR';
export const CLOSE_SNACKBAR = 'src/containers/CLOSE_SNACKBAR';
